<div
  class="add-item-dialog-header"
  style="
    padding: 30px 24px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  "
>
  <h1 style="font-size: 24px">Select Sender Info</h1>
  <button (click)="closeWithoutAddItem()">
    <i class="fas fa-times" style="font-size: 24px; color: red"></i>
  </button>
</div>

<div mat-dialog-content>
  <div class="select-sender-info-addresses-wrapper">
    <div
      *ngFor="let address of data; let ind = index;"
      class="select-sender-info-addresses-address"
    >
      <div>
        <div class="address-company" *ngIf="address?.company">
          Company: <span>{{address?.company}}</span>
        </div>
        <div class="address-line1" *ngIf="address?.line1">
          Line 1: <span>{{address?.line1}}</span>
        </div>
        <div class="address-line2" *ngIf="address?.line2">
          Line 2: <span>{{address?.line2}}</span>
        </div>
        <div class="address-city" *ngIf="address?.city_name">
          City: <span>{{address?.city_name}}</span>
        </div>
        <div class="address-state" *ngIf="address?.state">
          State: <span>{{address?.state}}</span>
        </div>
        <div class="address-country" *ngIf="address?.country_code">
          Country Code: <span>{{address?.country_code}}</span>
        </div>
        <div class="address-postcode" *ngIf="address?.post_code">
          Post Code: <span>{{address?.post_code}}</span>
        </div>
      </div>
      <div>
        <button
          mat-flat-button
          color="primary"
          class="shippn-mat-btn"
          (click)="selectAddressAndCloseDialog(ind)"
          cdkFocusInitial
        >
          Select Sender
        </button>
      </div>
    </div>
  </div>
</div>

<!-- <div mat-dialog-actions style="justify-content: flex-end">
  <button
    mat-flat-button
    color="primary"
    class="shippn-mat-btn"
    (click)="selectAddressAndCloseDialog()"
    cdkFocusInitial
  >
    Save Changes
  </button>
</div> -->
